import React, { Fragment, useEffect, useState } from 'react'
import { Table, TableHead, TableBody, Panel, PanelHeader, PanelFooter, Modal, Search } from '../../shared'
import {useAppDispatch, useAppSelector} from "../../core/hooks";
import {
  validateInputs,
  clearForm,
  getEntities,
  updateEntity,
  createEntity,
  setEntity, deleteEntity, selectEntity
} from './entity-slice'
import { Autocomplete, Button } from '../../ui-components'
import {CloseIcon, PlusIcon, EditIcon} from "../../assets";
import {togglePopover} from "../../admin/app-slice";
import styles from './entity.module.scss'
import EntityForm from './entity-form'
import { CITIES } from '../../services/constants'

const Entity = () => {
  const dispatch = useAppDispatch()
  const app = useAppSelector(state => state.adminApp)
  const {form, entities, entity} = useAppSelector(state => state.entity)
  const head = ['id', 'Имя', 'Название', 'Телефон', 'Почта', 'Адрес', 'Город', 'ИНН', '']
  const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false)
  const [searchQuery, setSearchQuery] = useState<string>('')
  const [entityList, setEntityList] = useState<any[]>([])
  const [selectedRegion, setSelectedRegion] = useState<string>('Все')
  useEffect(() => {
    dispatch(getEntities())
      .then(res => {
        if(res && res.length) {
          setEntityList(res)
        }
      })
  }, [dispatch])

  useEffect(() => {
    handleSelectRegion(selectedRegion)
  }, [entities])

  const submitForm = () => {
    for (const k in form) {
      dispatch(validateInputs({key: k, value: form[k]}))
    }
    if(entity){
      return dispatch(updateEntity())
        .then((res) => {
          if (res && res.length) {
            setEntityList(res)
          }
        } )
    }
    return dispatch(createEntity())
  }

  const closePopover = () => {
    dispatch(setEntity(null))
    dispatch(clearForm())
    dispatch(togglePopover('entityAddOrganization'))
  }

  const deleteOrg = async (organization) => {
    dispatch(clearForm())
    dispatch(setEntity(null))
    dispatch(deleteEntity(organization.uuid)).then(res => {
      if (res.deleted) {
        setDeleteModalOpen(false)
        dispatch(togglePopover('entityAddOrganization'))
        dispatch(getEntities())
      }
    })
  }

  const rows = entityList.map((val: any) => {
    if(!val.deleted) {
      return (
        <div className='row' key={val.id}>
          <div className='item'>
            {val.id}
          </div>
          <div className='item' title={val.name}>
            <strong>{val.name}</strong>
          </div>
          <div className='item' title={val.organization_name}>
            <strong>{val.organization_name}</strong>
          </div>
          <div className='item' title={val.primary_phone}>
            {val.primary_phone}
          </div>
          <div className='item' title={val.email}>
            {val.email}
          </div>
          <div className='item' title={val.address}>
            {val.address}
          </div>
          <div className='item' title={val.city}>
            {val.city}
          </div>
          <div className='item' title={val.taxpayer_number}>
            {val.taxpayer_number}
          </div>
          <div className='item'>
            <EditIcon onClick={() => {
              dispatch(selectEntity(val))
              dispatch(togglePopover('entityAddOrganization'))
            }}/>
          </div>
        </div>
      )
    }
  })

  const filterChange = (value: string, selectedCity = '') => {
    if (value) {
      setSearchQuery(value)
      const city = selectedCity || selectedRegion
      // @ts-ignore
      const searchedValue = entities.filter(h => h.name.toLowerCase().includes(value.toLowerCase()) || h.primary_phone.includes(value) || h.taxpayer_number.includes(value) || h.organization_name.toLowerCase().includes(value.toLowerCase()))
      setEntityList(city !== 'Все' ? searchedValue.filter(h => h.city === city) : searchedValue)
    } else {
      setSearchQuery('')
      setEntityList(entities)
    }
  }

  const handleSelectRegion = (value) => {
    setSelectedRegion(value)
    // @ts-ignore
    setEntityList(value !== 'Все' ? entities.filter(h => h.city === value) : entities)
    if (searchQuery) {
      filterChange(searchQuery, value)
    }
  }

  const popoverTitle = entity ? 'Сохранить' : 'Создать'

  return (
    <Fragment>
      <div id={styles.entityList}>
        <div className={'mb-20 space-between d-flex'}>
          <Autocomplete className={styles.search}
                        options={CITIES}
                        isClearable={false}
                        value={selectedRegion}
                        label={'Регион'}
                        onChange={(data) => handleSelectRegion(data.value)}
                        optionLabel={'value'}
                        optionValue={'value'}/>
          <div className={'flex-end d-flex full-width'}>
            <Search handleChange={e => {
              filterChange(e.target.value)
            }} value={searchQuery}/>
            <Button type='contained'
                    color='secondary'
                    onClick={() => dispatch(togglePopover('entityAddOrganization'))}
                    startIcon={<PlusIcon/>}>Добавить</Button>
          </div>
        </div>
        <Table>
          <TableHead>
            {head.map((el, i) => <div className='item' key={i}>{el}</div>)}
          </TableHead>
          <TableBody>
            {rows}
          </TableBody>
        </Table>
      </div>
      <Panel open={app.entityAddOrganization}
             handleClose={() =>closePopover()}>
        <PanelHeader className='simple-header'>
          <p>{popoverTitle} Юр. лицо</p>
          <CloseIcon onClick={() => closePopover()}/>
        </PanelHeader>
        <EntityForm entity={entity}/>
        <PanelFooter className='action-box'>
          {entity && <Button type='contained' onClick={() => setDeleteModalOpen(true)} className='ml-20'>Удалить</Button>}
          <Button type='simple' onClick={() => closePopover()}>Отмена</Button>
          <Button type='contained' onClick={submitForm} className='ml-20'>{popoverTitle}</Button>
        </PanelFooter>
      </Panel>
      <Modal open={deleteModalOpen}
             closeIcon
             title={'Удалить юр лицо?'}
             handleClose={() => {
               setDeleteModalOpen(false)
             }}>
        <p className="modalText mb-50">Вы уверены, что хотите удалить юр лицо?</p>
        <div className='d-flex space-between'>
          <Button type='contained'
                  fullWidth
                  onClick={() => deleteOrg(entity)}>Да</Button>
          <Button className={`ml-30`}
                  fullWidth
                  type='outlined'
                  onClick={() => setDeleteModalOpen(false)}>Нет</Button>
        </div>
      </Modal>
    </Fragment>
  )
}

export default Entity
